var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createSlots as _createSlots } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "px-10 flex flex-col justify-center items-center absolute w-full h-full top-0 left-0 bg-white bg-opacity-70 z-20"
};
const _hoisted_2 = { class: "w-full flex-row grid grid-cols-2 justify-center gap-1 border-b border-slate-300" };
const _hoisted_3 = {
    class: "flex flex-col border-r border-slate-300 pr-8 hl-variation-left pb-8 overflow-y-auto",
    style: { "max-height": "550px", "padding-right": "2rem" }
};
const _hoisted_4 = {
    class: "w-full space-y-1",
    style: { "flex": "0 0 auto" }
};
const _hoisted_5 = {
    key: 0,
    style: { "width": "640px" },
    class: "text-gray-700 flex flex-wrap space-x-1"
};
const _hoisted_6 = {
    style: { "flex": "0 0 auto" },
    class: "font-medium flex-none"
};
const _hoisted_7 = { style: { "flex": "1 1 150px" } };
const _hoisted_8 = {
    key: 1,
    style: { "width": "640px" },
    class: "text-gray-700 flex flex-wrap space-x-1"
};
const _hoisted_9 = {
    style: { "flex": "0 0 auto" },
    class: "font-medium flex-none"
};
const _hoisted_10 = {
    style: { "flex": "1 1 150px" },
    class: "capitalize"
};
const _hoisted_11 = {
    key: 2,
    style: { "width": "640px" },
    class: "text-gray-700 flex flex-wrap space-x-1"
};
const _hoisted_12 = {
    style: { "flex": "0 0 auto" },
    class: "font-medium flex-none"
};
const _hoisted_13 = { style: { "flex": "1 1 150px" } };
const _hoisted_14 = {
    key: 3,
    style: { "width": "640px" },
    class: "text-gray-700 flex flex-wrap space-x-1"
};
const _hoisted_15 = {
    style: { "flex": "0 0 auto" },
    class: "font-medium flex-none"
};
const _hoisted_16 = { style: { "flex": "1 1 150px" } };
const _hoisted_17 = {
    key: 4,
    style: { "width": "640px" },
    class: "text-gray-700 flex flex-wrap space-x-1"
};
const _hoisted_18 = {
    style: { "flex": "0 0 auto" },
    class: "font-medium flex-none"
};
const _hoisted_19 = {
    key: 5,
    class: "text-gray-700 flex items-center flex-1 font-normal text-start space-x-1 pb-2"
};
const _hoisted_20 = { class: "font-medium" };
const _hoisted_21 = { class: "capitalize" };
const _hoisted_22 = {
    key: 6,
    class: "flex flex-row justify-start py-4"
};
const _hoisted_23 = ["innerHTML"];
const _hoisted_24 = { class: "pl-8 space-y-3 flex flex-col justify-start items-start" };
import { fieldsMapping } from '@/compositions/useFormFields';
import { Copy01Icon, InfoCircleIcon, RefreshCcw02Icon, } from '@gohighlevel/ghl-icons/24/outline';
import { UIButton, UICard, UIDivider, UIInput, UIModal, UIModalContent, UIModalFooter, UIModalHeader, UISpace, UISpin, UITag, UITextSmMedium, UITextSmNormal, UITextSmRegular, UITextXsMedium, UITooltip, } from '@gohighlevel/ghl-ui';
import { computed, inject, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import { ContentAIServices } from '../../service/ContentAIService';
import { FormFieldNames, ModuleType, SubTypeLabel, } from '../../types';
export default /*#__PURE__*/ _defineComponent({
    __name: 'ModalShowVariations',
    props: {
        showModal: {
            type: Boolean,
            default: false,
        },
        transactionId: {
            type: String,
            default: '',
        },
        hideControls: {
            type: Boolean,
            default: false,
        },
        productType: {
            type: String,
            require: true,
        },
    },
    emits: ['close', 'regenerate', 'contentId'],
    setup(__props, { emit: emits }) {
        const props = __props;
        const { t } = useI18n();
        const route = inject('route');
        const loading = ref(true);
        const coping = ref(false);
        const updating = ref(false);
        const contentStore = ref();
        const content = ref('');
        const id = computed(() => props.transactionId);
        const storeUpdate = computed(() => contentStore.value);
        const show = computed(() => props.showModal);
        const formFields = computed(() => {
            var _a, _b;
            return fieldsMapping[`${props.productType}_${(_a = contentStore.value) === null || _a === void 0 ? void 0 : _a.subType}`]
                ? fieldsMapping[`${props.productType}_${(_b = contentStore.value) === null || _b === void 0 ? void 0 : _b.subType}`]
                : fieldsMapping[props.productType];
        });
        watch(show, () => __awaiter(this, void 0, void 0, function* () {
            content.value = '';
            if (id.value) {
                yield fetchVariations();
            }
        }));
        watch(storeUpdate, () => {
            content.value = '';
            if (storeUpdate.value.content) {
                content.value = replaceCustomVariableStrings(storeUpdate.value.content.trim());
            }
        });
        onMounted(() => __awaiter(this, void 0, void 0, function* () {
            if (id.value)
                yield fetchVariations();
        }));
        const selectedVariation = ref();
        function copy(variation) {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (coping.value)
                        return;
                    coping.value = true;
                    if (!props.hideControls) {
                        if (!content.value)
                            content.value = variation.response.trim();
                        else
                            content.value += `\n` + variation.response.trim();
                        selectedVariation.value = Object.assign(Object.assign({}, variation), { response: content.value });
                    }
                    const body = {
                        variation: {
                            id: variation._id,
                            usedInPost: true,
                        },
                        content: variation.response,
                        locationId: (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id,
                    };
                    yield ContentAIServices.updateContentById(id.value, body);
                    if (props.hideControls)
                        clipboardCopy(variation.response);
                    coping.value = false;
                }
                catch (error) {
                    coping.value = false;
                }
            });
        }
        function submitVariation() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    if (updating.value)
                        return;
                    updating.value = true;
                    const body = {
                        content: content.value,
                        locationId: (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id,
                    };
                    yield ContentAIServices.updateContentById(id.value, body);
                    emits('contentId', id.value);
                    updating.value = false;
                    closeModal();
                }
                catch (error) {
                    updating.value = false;
                }
            });
        }
        function fetchVariations() {
            var _a;
            return __awaiter(this, void 0, void 0, function* () {
                try {
                    loading.value = true;
                    const { data } = yield ContentAIServices.getVariationsById(id.value, (_a = route === null || route === void 0 ? void 0 : route.params) === null || _a === void 0 ? void 0 : _a.location_id);
                    data.variations = data.variations.map((d) => {
                        return Object.assign(Object.assign({}, d), { response: replaceCustomVariableStrings(d.response) });
                    });
                    contentStore.value = data;
                    loading.value = false;
                }
                catch (error) {
                    loading.value = false;
                }
            });
        }
        function replaceCustomVariableStrings(content) {
            if (props.productType == ModuleType.EMAIL_BUILDER) {
                const locationName = /\[Your Name\]/gi;
                const firstName = /\[Name\]|\[Recipient\]|\[Recipient's name\]|\[Recipient name\]|\[Recipient's Name\]/gi;
                return content
                    .replace(locationName, '{{location.name}}')
                    .replace(firstName, '{{contact.first_name}}');
            }
            return content;
        }
        function wordCount(str) {
            const newStr = str.replace(/\n/g, ' ');
            return newStr.split(' ').filter(function (n) {
                return n.trim() != '';
            }).length;
        }
        function closeModal() {
            if (updating.value || coping.value || loading.value)
                return;
            emits('close');
            content.value = '';
        }
        function regenerateContent() {
            emits('regenerate', {
                source: contentStore.value.type,
                type: contentStore.value.subType,
                formValues: contentStore.value,
            });
            content.value = '';
        }
        function clipboardCopy(content) {
            navigator.clipboard.writeText(content);
        }
        function getSubType(type) {
            if (type)
                return t(SubTypeLabel[type]);
            return '';
        }
        function getHtmlPageBreakString(content) {
            return content.replace(/\n/g, '<br/>');
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(_unref(UIModal), {
                show: __props.showModal,
                width: 1400
            }, _createSlots({
                header: _withCtx(() => [
                    _createVNode(_unref(UIModalHeader), {
                        id: "content-ai-new-post-variations-modal-header",
                        title: _ctx.$t('common.title'),
                        description: "",
                        onClose: closeModal
                    }, null, 8, ["title"])
                ]),
                default: _withCtx(() => [
                    _createVNode(_unref(UIModalContent), { id: "content-ai-new-post-variations-modal-content" }, {
                        default: _withCtx(() => {
                            var _a, _b, _c, _d, _e, _f;
                            return [
                                (loading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                        _createVNode(_unref(UISpin), { size: "large" })
                                    ]))
                                    : _createCommentVNode("", true),
                                _createElementVNode("div", _hoisted_2, [
                                    _createElementVNode("div", _hoisted_3, [
                                        _createElementVNode("div", _hoisted_4, [
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).SUB_TYPE))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                                    _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('showVariationsModal.type')), 1),
                                                    _createElementVNode("span", _hoisted_7, _toDisplayString(getSubType((_a = contentStore.value) === null || _a === void 0 ? void 0 : _a.subType)), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).CONTEXT))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                                    _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('showVariationsModal.context')), 1),
                                                    _createElementVNode("span", _hoisted_10, _toDisplayString((_b = contentStore.value) === null || _b === void 0 ? void 0 : _b.emailContext), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).TITLE))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                                    _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('showVariationsModal.contentTitle')), 1),
                                                    _createElementVNode("span", _hoisted_13, _toDisplayString((_c = contentStore.value) === null || _c === void 0 ? void 0 : _c.title), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).DESCRIPTION))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.$t('showVariationsModal.descriptionLabel')), 1),
                                                    _createElementVNode("span", _hoisted_16, _toDisplayString((_d = contentStore.value) === null || _d === void 0 ? void 0 : _d.description), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).KEYWORDS))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                                                    _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t('showVariationsModal.keywordsLabel')), 1),
                                                    _createVNode(_unref(UISpace), { style: { "flex": "1 1 150px" } }, {
                                                        default: _withCtx(() => {
                                                            var _a;
                                                            return [
                                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = contentStore.value) === null || _a === void 0 ? void 0 : _a.keywords, (tag) => {
                                                                    return (_openBlock(), _createBlock(_unref(UITag), {
                                                                        key: tag,
                                                                        class: "capitalize"
                                                                    }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(tag), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024));
                                                                }), 128))
                                                            ];
                                                        }),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            (_unref(formFields).fields.includes(_unref(FormFieldNames).TONE) ||
                                                ((_e = contentStore.value) === null || _e === void 0 ? void 0 : _e.tone))
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                    _createElementVNode("span", _hoisted_20, _toDisplayString(_ctx.$t('showVariationsModal.writingTone')), 1),
                                                    _createElementVNode("span", _hoisted_21, _toDisplayString(((_f = contentStore.value) === null || _f === void 0 ? void 0 : _f.tone)
                                                        ? _ctx.$t(`generateContentModal.writingToneOptions.${contentStore.value.tone}`)
                                                        : ''), 1)
                                                ]))
                                                : _createCommentVNode("", true),
                                            (!__props.hideControls)
                                                ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                    _createVNode(_unref(UITag), {
                                                        type: "info",
                                                        class: "cursor-pointer",
                                                        onClick: regenerateContent
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UISpace), { align: "center" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(RefreshCcw02Icon), { class: "w-4 h-4" }),
                                                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('showVariationsModal.generateNewContent')), 1)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    })
                                                ]))
                                                : _createCommentVNode("", true),
                                            _createVNode(_unref(UIDivider)),
                                            _createVNode(_unref(UISpace), {
                                                class: "flex-auto pt-5",
                                                vertical: true,
                                                size: "large"
                                            }, {
                                                default: _withCtx(() => {
                                                    var _a;
                                                    return [
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_a = contentStore.value) === null || _a === void 0 ? void 0 : _a.variations, (variation, index) => {
                                                            return (_openBlock(), _createBlock(_unref(UICard), {
                                                                class: "min-w-full text-start",
                                                                key: variation._id
                                                            }, {
                                                                header: _withCtx(() => [
                                                                    _createVNode(_unref(UITag), { type: "success" }, {
                                                                        default: _withCtx(() => [
                                                                            _createTextVNode(_toDisplayString(_ctx.$t('showVariationsModal.contentVariation')) + " " + _toDisplayString(index + 1), 1)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                footer: _withCtx(() => [
                                                                    _createVNode(_unref(UISpace), {
                                                                        align: "center",
                                                                        justify: "space-between"
                                                                    }, {
                                                                        default: _withCtx(() => {
                                                                            var _a;
                                                                            return [
                                                                                _createVNode(_unref(UITextXsMedium), { class: "text-gray-600" }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createTextVNode(_toDisplayString(wordCount(variation.response)) + " " + _toDisplayString(_ctx.$t('common.words')), 1)
                                                                                    ]),
                                                                                    _: 2
                                                                                }, 1024),
                                                                                _createVNode(_unref(UIButton), {
                                                                                    id: "content-ai-new-post-variation-copy-btn",
                                                                                    onClick: ($event) => (copy(variation)),
                                                                                    loading: coping.value && ((_a = selectedVariation.value) === null || _a === void 0 ? void 0 : _a._id) == variation._id
                                                                                }, {
                                                                                    default: _withCtx(() => [
                                                                                        _createVNode(_unref(UISpace), { align: "center" }, {
                                                                                            default: _withCtx(() => [
                                                                                                _createVNode(_unref(Copy01Icon), { class: "w-4 h-5" }),
                                                                                                _createElementVNode("span", null, _toDisplayString(_ctx.$t('showVariationsModal.copy')), 1)
                                                                                            ]),
                                                                                            _: 1
                                                                                        })
                                                                                    ]),
                                                                                    _: 2
                                                                                }, 1032, ["onClick", "loading"])
                                                                            ];
                                                                        }),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(UITextSmNormal), null, {
                                                                        default: _withCtx(() => [
                                                                            _createElementVNode("span", {
                                                                                innerHTML: getHtmlPageBreakString(variation.response)
                                                                            }, null, 8, _hoisted_23)
                                                                        ]),
                                                                        _: 2
                                                                    }, 1024)
                                                                ]),
                                                                _: 2
                                                            }, 1024));
                                                        }), 128))
                                                    ];
                                                }),
                                                _: 1
                                            })
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_24, [
                                        _createVNode(_unref(UISpace), { align: "center" }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UITextSmMedium), null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('showVariationsModal.chosenContent')), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                (__props.productType == _unref(ModuleType).EMAIL_BUILDER)
                                                    ? (_openBlock(), _createBlock(_unref(UITooltip), { key: 0 }, {
                                                        trigger: _withCtx(() => [
                                                            _createVNode(_unref(InfoCircleIcon), { class: "w-4 h-4 text-primary-400" })
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('showVariationsModal.emailBuilderTooltip')), 1)
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        }),
                                        _createVNode(_unref(UIInput), {
                                            id: "content-ai-variations-modal-textarea",
                                            type: "textarea",
                                            size: "large",
                                            modelValue: content.value,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((content).value = $event)),
                                            readonly: __props.hideControls,
                                            rows: 15,
                                            placeholder: _ctx.$t('showVariationsModal.chosenContentPlaceholder')
                                        }, null, 8, ["modelValue", "readonly", "placeholder"]),
                                        _createVNode(_unref(UISpace), {
                                            align: "center",
                                            justify: "space-between",
                                            class: "w-full"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_unref(UITextSmRegular), null, {
                                                    default: _withCtx(() => [
                                                        _createTextVNode(_toDisplayString(`${wordCount(content.value || '')} ${_ctx.$t('common.words')}`), 1)
                                                    ]),
                                                    _: 1
                                                }),
                                                (__props.hideControls)
                                                    ? (_openBlock(), _createBlock(_unref(UIButton), {
                                                        key: 0,
                                                        id: "content-ai-new-post-variation-copy-btn",
                                                        onClick: _cache[1] || (_cache[1] = ($event) => (clipboardCopy(content.value)))
                                                    }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_unref(UISpace), { align: "center" }, {
                                                                default: _withCtx(() => [
                                                                    _createVNode(_unref(Copy01Icon), { class: "w-4 h-5" }),
                                                                    _createElementVNode("span", null, _toDisplayString(_ctx.$t('showVariationsModal.copy')), 1)
                                                                ]),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ])
                            ];
                        }),
                        _: 1
                    })
                ]),
                _: 2
            }, [
                (!__props.hideControls)
                    ? {
                        name: "footer",
                        fn: _withCtx(() => [
                            _createVNode(_unref(UIModalFooter), {
                                positiveText: _ctx.$t('showVariationsModal.continue'),
                                negativeText: _ctx.$t('showVariationsModal.cancel'),
                                onNegativeClick: closeModal,
                                id: "content-ai-new-variations-modal-footer",
                                onPositiveClick: submitVariation,
                                loading: updating.value,
                                disabled: !content.value.length
                            }, null, 8, ["positiveText", "negativeText", "loading", "disabled"])
                        ]),
                        key: "0"
                    }
                    : undefined
            ]), 1032, ["show"]));
        };
    }
});
